import { render } from "./headColumn.vue?vue&type=template&id=0681f024&scoped=true&ts=true"
import script from "./headColumn.vue?vue&type=script&lang=ts"
export * from "./headColumn.vue?vue&type=script&lang=ts"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0681f024"]])

export default __exports__